import React from "react";
import {Route, Routes} from "react-router-dom";
import CreateCategory from "../container/education/category/CreateCategory";
import MainCategoryList from "../container/education/category/MainCategoryList";
import MiddleCategoryList from "../container/education/category/MiddleCategoryList";
import SubCategoryList from "../container/education/category/SubCategoryList";
import UpdateCategory from "../container/education/category/UpdateCategory";
import CreateCurriculum from "../container/education/curriculum/CreateCurriculum";
import CurriculumList from "../container/education/curriculum/CurriculumList";
import CurriculumReport from "../container/education/curriculum/CurriculumReport";
import UpdateCurriculum from "../container/education/curriculum/UpdateCurriculum";
import EditExam from "../container/education/Exam/EditExam";
import MyEval from "../container/education/Exam/MyEval";
import StartExam from "../container/education/Exam/StartExam";
import TakeExam from "../container/education/Exam/TakeExam";
import CreateTutor from "../container/education/tutor/CreateTutor";
import TutorList from "../container/education/tutor/TutorList";
import UpdateTutor from "../container/education/tutor/UpdateTutor";
import ExamResult from "../container/education/Exam/ExamResult";
import ExamRank from "../container/education/Exam/ExamRank";
import ExamReport from "../container/education/Exam/ExamReport";
import ExcludeExam from "../container/education/Exam/ExcludeExam";
import ExamQRCode from "../container/education/Exam/ExamQRCode";
import ExamScore from "../container/education/Exam/ExamScore";

const Education = () => {
  return (
    <Routes>
      <Route path="CurriculumList" element={<CurriculumList />} />
      <Route path="CreateCurriculum" element={<CreateCurriculum />} />
      <Route path="UpdateCurriculum/:id" element={<UpdateCurriculum />} />
      <Route path="CurriculumReport/:id" element={<CurriculumReport />} />
      <Route path="ExamQRCode/:id" element={<ExamQRCode />} />

      <Route path="EditExam/:id" element={<EditExam />} />
      <Route path="MyEval" element={<MyEval />} />
      <Route path="StartExam/:id" element={<StartExam />} />
      <Route path="TakeExam/:id" element={<TakeExam />} />
      <Route path="ExamResult" element={<ExamResult />} />
      <Route path="ExamRank/:id" element={<ExamRank />} />
      <Route path="ExamScore/:id" element={<ExamScore />} />
      <Route path="ExamReport/:id" element={<ExamReport />} />
      <Route path="ExcludeExam/:id/:uid" element={<ExcludeExam />} />

      <Route path="TutorList" element={<TutorList />} />
      <Route path="CreateTutor" element={<CreateTutor />} />
      <Route path="UpdateTutor/:id" element={<UpdateTutor />} />

      <Route path="CategoryList" element={<MainCategoryList />} />
      <Route path="MiddleCategoryList/:param" element={<MiddleCategoryList />} />
      <Route path="SubCategoryList/:param" element={<SubCategoryList />} />
      <Route path="Create/:param1/:param2" element={<CreateCategory />} />
      <Route path="Update/:param1/:param2" element={<UpdateCategory />} />
    </Routes>
  );
};

export default Education;
